// extracted by mini-css-extract-plugin
module.exports = {"subheading":"page_subheading__y0lDC"};